// extracted by mini-css-extract-plugin
export default {"title":"xzU8Bb"};